import React from 'react';
import { MoonIcon, SunIcon } from '@heroicons/react/24/outline';
import { useTheme } from '../../context/ThemeContext';
import Tooltip from '../../ui/Tooltip/Tooltip';

function TopBarThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <Tooltip content="Alterna o tema entre claro e escuro para melhorar conforto visual." variant="tip">
      <button
        type="button"
        className="mp-topbar__icon-btn mp-topbar__theme-btn"
        onClick={toggleTheme}
        aria-label={isDark ? 'Ativar tema claro' : 'Ativar tema escuro'}
      >
        {isDark ? (
          <SunIcon className="mp-topbar__icon-svg" />
        ) : (
          <MoonIcon className="mp-topbar__icon-svg" />
        )}
      </button>
    </Tooltip>
  );
}

export default TopBarThemeToggle;